module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"group":"Grupo","item":"Item"},"en":{"group":"Group","item":"Item"}}')
  delete Component.options._Ctor
}
